import React, { useEffect } from 'react';
// import { Modal, Icon } from 'antd';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkCycle } from 'app/actions/WorkCycleActions';
import { fetchWorkCycleFilter, clearWorkCycle, workCycleFilterClear } from 'app/actions/WorkCycleActions';
import { clearTestQuestion } from 'app/actions/TestActions';
import { getWorkCycle, getWorkCycleFilter, getIsLoadingWorkCycleFilter } from 'app/reducers';
import ApiService from 'app/services/ApiService';
import isEmpty from 'app/utils/IsEmpty';

import { employeeById } from 'app/reducers';

import IconButton from '@material-ui/core/IconButton';

export default function WorkCycleTableContainer(props) {
    const { confirm } = Modal;
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;


    const employeeData = useSelector(employeeById);
    const { siteId } = useSelector(state => state.Auth);

    const columns = [
        {
            title: 'Folio',
            dataIndex: 'testFolio',
            key: 'testFolio',
            width: 100,
            sorter: true,
        },
        {
            title: 'Nombre',
            dataIndex: 'testTitle',
            key: 'name',
            sorter: true,
            ellipsis: true,
            width: 200
        },
        {
            title: 'Descripción',
            dataIndex: 'testDescription',
            key: 'description',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {
            title: 'Preguntas',
            dataIndex: 'isConfigured',
            className: 'alignCenter',
            key: 'questions',
            width: 120,
            sorter: true,
            render: hasQuestions => (
                hasQuestions ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} />
            )
        },
        {
            title: 'Fecha creación',
            dataIndex: 'creationDate',
            key: 'creationDate',
            sorter: true,
            className: 'alignCenter',
            width: 160,
            render: record => new Date(record).toLocaleDateString()
        },
        {
            title: 'Fecha modificación',
            dataIndex: 'modificationDate',
            key: 'modificationDate',
            sorter: true,
            className: 'alignCenter',
            width: 160,
            render: record => new Date(record).toLocaleDateString()
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'status',
            sorter: true,
            width: 120
        },
        {

        },
        {
            title: 'Acciones',
            dataIndex: 'idTest',
            key: 'actions',
            fixed: 'right',
            width: 120,
            render: (id, params) => (
                <div>

                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={props.classes.deleteIcon} onClick={() => showConfirmDelete(id)} disabled={params.statusName === 'ASIGNADO'}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={props.classes.editIcon} onClick={() => showTabEdit(id)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];


    async function deleteWorkCycles(id) {
        await ApiService.deleteWorkCycles(id).then(
            res => {
                dispatch(clearWorkCycle());
                dispatch(workCycleFilterClear());
                fetchWorkCycleFilterAction();
                dispatch(fetchWorkCycle({ ...props.formData, Subdirection: employeeData.idSubdirection }));
                const modal = Modal.success({
                    title: `Eliminado Correctamente`,
                    content: '',
                });
                setTimeout(function () {
                    modal.destroy();
                }, 3000)

            });
    }

    let workCycle = useSelector(getWorkCycle);
    let workCycleFilter = useSelector(getWorkCycleFilter);
    let isLoading = useSelector(getIsLoadingWorkCycleFilter);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(workCycle)) fetchWorkCycleAction();
        if (isEmpty(workCycleFilter)) fetchWorkCycleFilterAction();
    }, []);

    const showTabEdit = (id) => {
        props.setTab('3')
        props.setIdTest(id)
        dispatch(clearTestQuestion());
        dispatch(workCycleFilterClear());
        fetchWorkCycleFilterAction();

    }

    const showConfirmDelete = (id) => {
        let workcycle = workCycle.find(data => data['idTest'] === id);
        confirm({
            title: '¿Eliminar Ciclo de trabajo?',
            content: workcycle.testTitle,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(workCycleFilterClear());
                fetchWorkCycleFilterAction();
                return deleteWorkCycles(id);
            },
            onCancel() { },
        });

    }

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(fetchWorkCycle(
            {
                TestFolio: (props.formData.TestFolio === undefined) ? '' : props.formData.TestFolio,
                CourseFolio: (props.formData.CourseFolio === undefined) ? '' : props.formData.CourseFolio,
                TestTitle: (props.formData.TestTitle === undefined) ? '' : props.formData.TestTitle,
                TestDescription: (props.formData.TestDescription === undefined) ? '' : props.formData.TestDescription,
                Subdirection: [employeeData.idSubdirection],
                InitialCreationDate: (props.formData.InitialCreationDate === undefined) ? '' : props.formData.InitialCreationDate,
                FinalCreationDate: (props.formData.FinalCreationDate === undefined) ? '' : props.formData.FinalCreationDate,
                InitialRevDate: (props.formData.InitialRevDate === undefined) ? '' : props.formData.InitialRevDate,
                FinalRevDate: (props.formData.FinalRevDate === undefined) ? '' : props.formData.FinalRevDate,
                ListStatus: (props.formData.ListStatus === undefined) ? '' : props.formData.ListStatus,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));

    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && workCycle.length > 0) {
            pagination.total = workCycle[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter !== undefined) {
        column = sorter.field === undefined ? '' : sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchWorkCycleAction = () => dispatch(fetchWorkCycle({ subdirection: employeeData.idSubdirection }));
    const fetchWorkCycleFilterAction = () => dispatch(fetchWorkCycleFilter({ subdirection: employeeData.idSubdirection }))
    workCycle.map(item => item['key'] = item.idTest);
    return (props.children({ cols: columns, workCycle, workCycleFilter, isLoading, handleTableChange }));
}